export const STOP_LOCATION_LAYER = "stopLocationLayer";
export const STOP_LOCATIONS_SOURCE = "stopLocationsSource";
export const CURRENT_LOCATION_CIRCLE_LAYER = "currentLocationCircleLayer";
export const CURRENT_LOCATION_CIRCLE = "currentLocationCircle";
export const CURRENT_LOCATION_RADIUS_LAYER = "currentLocationRadiusLayer";
export const CURRENT_LOCATION_RADIUS = "currentLocationRadius";
